import { trpc } from '@/shared/api';

/** 문의 목록·주문별 목록·상세를 다시 불러오게 한다(답변 직후 상세가 답변 뷰로 바뀐다). */
export const useInvalidateOrderInquiries = (): (() => void) => {
  const utils = trpc.useUtils();
  return () => {
    void utils.orderInquiryManagement.list.invalidate();
    void utils.orderInquiryManagement.listByOrder.invalidate();
    void utils.orderInquiryManagement.get.invalidate();
  };
};
